export const uz: Record<string, string> = {
  'app.title': 'Butilka',

  'common.ok': 'OK',
  'common.cancel': 'Bekor qilish',
  'common.close': 'Yopish',
  'common.back': 'Orqaga',
  'common.retry': 'Qayta urinish',
  'common.save': 'Saqlash',
  'common.send': 'Yuborish',
  'common.loading': 'Yuklanmoqda…',
  'common.reconnecting': 'Aloqa uzildi. Qayta ulanmoqda…',
  'common.offline': 'Internet yoʻq',
  'common.hearts': '❤ {count}',
  'common.optional': 'ixtiyoriy',

  'errors.BAD_REQUEST': 'Soʻrovda xatolik bor.',
  'errors.VALIDATION_FAILED': 'Kiritilgan maʼlumotlarni tekshiring.',
  'errors.UNAUTHORIZED': 'Oʻyinni Telegram orqali qayta oching.',
  'errors.TOKEN_EXPIRED': 'Sessiya tugadi. Qayta ulanmoqda…',
  'errors.FORBIDDEN': 'Bu amalga ruxsat yoʻq.',
  'errors.NOT_FOUND': 'Topilmadi.',
  'errors.CONFLICT': 'Maʼlumot oʻzgargan. Qayta urinib koʻring.',
  'errors.UNPROCESSABLE': 'Hozir bu amalni bajarib boʻlmaydi.',
  'errors.RATE_LIMITED': 'Juda tez! Biroz kuting.',
  'errors.PAYLOAD_TOO_LARGE': 'Juda uzun.',
  'errors.UNIQUE_VIOLATION': 'Bu allaqachon mavjud.',
  'errors.INTERNAL_ERROR': 'Nimadir xato ketdi. Qayta urinib koʻring.',
  'errors.SERVICE_UNAVAILABLE': 'Oʻyin qayta ishga tushmoqda. Birozdan keyin qayting.',
  'errors.INIT_DATA_INVALID': 'Oʻyinni Telegram bot orqali oching.',
  'errors.INIT_DATA_EXPIRED': 'Kirish havolasi eskirgan. Oʻyinni botdan qayta oching.',
  'errors.BANNED': 'Akkauntingiz bloklangan.',
  'errors.ONBOARDING_REQUIRED': 'Avval profilingizni toʻldiring.',
  'errors.SESSION_REPLACED': 'Oʻyin boshqa qurilmada ochildi.',
  'errors.LOGIN_FAILED': 'Login yoki parol notoʻgʻri.',
  'errors.WRONG_PASSWORD': 'Joriy parol notoʻgʻri.',
  'errors.ROOM_NOT_FOUND': 'Bu stol endi mavjud emas.',
  'errors.ROOM_FULL': 'Stolda joy yoʻq.',
  'errors.ROOM_BUSY': 'Stol band. Qayta urinib koʻring.',
  'errors.NOT_IN_ROOM': 'Siz stolda emassiz.',
  'errors.NOT_YOUR_TURN': 'Hozir sizning navbatingiz emas.',
  'errors.NOT_IN_ROUND': 'Siz bu raundda qatnashmayapsiz.',
  'errors.STALE_TURN': 'Kech qoldingiz.',
  'errors.ALREADY_DECIDED': 'Siz allaqachon tanladingiz.',
  'errors.MUTED': 'Hozir chatga yoza olmaysiz.',
  'errors.BLOCKED': 'Bu oʻyinchi bilan muloqot qila olmaysiz.',
  'errors.MESSAGE_REJECTED': 'Bu xabarni yuborib boʻlmaydi. Havolalar va haqoratli soʻzlar taqiqlangan.',
  'errors.CANNOT_TARGET_SELF': 'Buni oʻzingizga qila olmaysiz.',
  'errors.INSUFFICIENT_FUNDS': 'Yuraklar yetarli emas.',
  'errors.INSUFFICIENT_GM': 'GM yetarli emas.',
  'errors.TRANSFER_LIMIT': 'Bugun yetarlicha yubordingiz. Ertaga urinib koʻring.',
  'errors.NOT_FRIENDS': 'Faqat doʻstlaringizga yuborish mumkin.',
  'errors.ALREADY_CLAIMED': 'Bugun olingan. Ertaga qayting!',
  'errors.GIFT_NOT_FOUND': 'Bu sovgʻa mavjud emas.',
  'errors.VIDEO_UNAVAILABLE': 'Bu videoni oʻyinda ijro etib boʻlmaydi. Boshqa havola yuboring.',
  'errors.NO_CHANCES': 'Imkoniyatlaringiz qolmadi.',
  'errors.NO_BOOSTER': 'Sizda bu booster yoʻq.',
  'errors.PRODUCT_NOT_FOUND': 'Bu toʻplam mavjud emas.',

  'gender.MALE': 'Erkak',
  'gender.FEMALE': 'Ayol',
  'locale.en': 'English',
  'locale.ru': 'Русский',
  'locale.uz': 'Oʻzbekcha',
  'locale.az': 'Azərbaycanca',
  'locale.tr': 'Türkçe',

  'onboarding.title': 'Butilka oʻyiniga xush kelibsiz!',
  'onboarding.subtitle': 'Butilkani aylantiring, oʻpishing, sovgʻa bering va yangi odamlar bilan tanishing.',
  'onboarding.language': 'Til',
  'onboarding.name': 'Stoldagi ismingiz',
  'onboarding.gender': 'Men',
  'onboarding.birth_year': 'Tugʻilgan yil',
  'onboarding.birth_year_hint': 'Ismingiz yonida yoshingiz koʻrinadi',
  'onboarding.rules_title': 'Stol qoidalari',
  'onboarding.rule_respect': 'Hurmat saqlang. Haqorat, spam va havolalar taqiqlangan.',
  'onboarding.rule_virtual': 'Oʻpish va sovgʻalar virtual — faqat koʻngilxushlik uchun.',
  'onboarding.rule_block': 'Istalgan oʻyinchini bloklash yoki shikoyat qilish mumkin.',
  'onboarding.adult': 'Men 18 yoshdan kattaman va stol qoidalariga roziman',
  'onboarding.start': 'Oʻynash',
  'onboarding.underage': 'Kechirasiz, oʻyin faqat 18 yoshdan katta oʻyinchilar uchun.',

  'lobby.play': 'OʻYNASH',
  'lobby.balance': 'Yuraklaringiz',
  'lobby.ratings': 'Reytinglar',
  'lobby.achievements': 'Yutuqlar',
  'lobby.shop': 'Yurak sotib olish',
  'lobby.settings': 'Sozlamalar',
  'lobby.invite': 'Doʻstlarni taklif qilish',
  'lobby.profile': 'Profil',

  'table.title': '{code}-stol',
  'table.waiting_players': 'Boshqa oʻyinchilar kutilmoqda…',
  'table.waiting_turn': 'Keyingi navbatni kuting',
  'table.your_turn': 'Butilkani aylantiring!',
  'table.tap_bottle': 'Butilkaga bosing',
  'table.spins': 'Butilkani aylantirmoqda',
  'table.your_choice': 'Sizning tanlovingiz',
  'table.kiss_back': 'Javoban oʻpadimi?',
  'table.will_they': 'Oʻpishadimi yoki yoʻq?',
  'table.kiss': 'Oʻpish',
  'table.refuse': 'Rad etish',
  'table.result_mutual': 'Oʻzaro oʻpish! 💋',
  'table.result_one': '{from} {to}ni oʻpdi 💋',
  'table.result_none': 'Bu safar oʻpish boʻlmadi',
  'table.change': 'Stolni almashtirish',
  'table.leave': 'Stoldan chiqish',
  'table.chat_placeholder': 'Xabar yozing',
  'table.chat_empty': 'Hammaga salom bering 👋',
  'table.music_on': 'Musiqa yoqiq',
  'table.music_off': 'Musiqa oʻchiq',
  'table.now_playing': 'Hozir yangramoqda',
  'table.tap_to_listen': 'Tinglash uchun bosing',
  'table.music_error': 'Bu videoni bu yerda ijro etib boʻlmaydi',
  'table.dj_title': 'Stol uchun qoʻshiq buyurtma qilish',
  'table.dj_hint': 'YouTube havolasini qoʻying. Stoldagi hamma eshitadi.',
  'table.dj_order': '❤ {price} ga buyurtma qilish',
  'table.dj_queue': 'Navbatda: {count}',
  'table.idle_kicked': 'Faol boʻlmaganingiz uchun stoldan chiqarildingiz.',
  'table.session_replaced': 'Oʻyin boshqa qurilmada ochildi.',
  'table.kisses.one': '{count} ta oʻpish',
  'table.kisses.other': '{count} ta oʻpish',
  'table.joined': '{name} stolga oʻtirdi',
  'table.left': '{name} stoldan chiqdi',
  'table.gift_sent': '{from} {to}ga {emoji} sovgʻa qildi',
  'table.dj_dedicated': '{name} {to} ga qoʻshiq bagʻishladi: {title}',
  'table.dj_for': '{name} uchun',
  'table.dj_dedicate': '{name} ga qoʻshiq bagʻishlash',
  'table.dj_video': 'Klip sifatida koʻrsatish (❤ {price})',
  'gifts.category.romance': 'Romantika',
  'gifts.category.hats': 'Shlyapa va tojlar',
  'gifts.category.animals': 'Hayvonlar',
  'gifts.category.music': 'Musiqa',
  'gifts.category.vip': 'VIP',
  'table.dj_ordered': '{name} qoʻshiq buyurtma qildi: {title}',

  'player.send_gift': 'Sovgʻa berish',
  'player.hidden_message': 'Yashirin xabar',
  'player.dare': 'Topshiriq',
  'player.admire': '❤ {price} ga muxlis boʻlish',
  'player.admirer': 'Muxlis: {name} (❤ {price})',
  'player.no_admirer': 'Hali muxlis yoʻq',
  'player.block': 'Bloklash',
  'player.unblock': 'Blokdan chiqarish',
  'player.report': 'Shikoyat qilish',
  'player.you': 'Bu sizsiz',
  'player.achievements.one': '{count} ta yutuq',
  'player.achievements.other': '{count} ta yutuq',

  'gifts.title': '{name}ga sovgʻa',
  'gifts.category.flowers': 'Gullar',
  'gifts.category.drinks': 'Ichimliklar',
  'gifts.category.sweets': 'Shirinliklar',
  'gifts.category.fun': 'Qiziqarli',
  'gifts.category.status': 'Hashamat',
  'gifts.category.pranks': 'Hazillar',
  'gifts.category.seasonal': 'Mavsumiy',

  'ratings.title': 'Reytinglar',
  'ratings.kisses': 'Eng koʻp oʻpilganlar',
  'ratings.dj': 'Eng yaxshi DJlar',
  'ratings.day': 'Bugun',
  'ratings.week': 'Shu hafta',
  'ratings.month': 'Shu oy',
  'ratings.all': 'Barcha vaqt',
  'ratings.you': 'Siz',
  'ratings.empty': 'Hali hech kim yoʻq. Birinchi boʻling!',

  'achievements.title': 'Yutuqlar',
  'achievements.progress': '{progress} / {threshold}',
  'achievements.reward': 'Mukofot: ❤ {reward}',

  'errors.VIP_REQUIRED': 'Bu faqat VIP oʻyinchilar uchun.',
  'errors.NOT_OWNED': 'Sizda hali bu narsa yoʻq.',
  'lobby.vip': 'VIP',
  'lobby.styling': 'Bezak',
  'vip.title': 'VIP status',
  'vip.active_until': 'VIP {date} gacha',
  'vip.inactive': 'Har bir stolda ajralib turing.',
  'vip.perk_name': 'Stol va chatda oltin ism va VIP belgisi',
  'vip.perk_bottle': 'Stolingiz uchun VIP butilka',
  'vip.perk_frames': 'Maxsus VIP ramkalar',
  'vip.perk_gifts': 'VIP sovgʻalar va stikerlar',
  'vip.plan': '{days} kun',
  'vip.buy': '❤ {price} ga olish',
  'vip.extend': '❤ {price} ga uzaytirish',
  'vip.bought': 'Siz {date} gacha VIP! 👑',
  'styling.title': 'Bezak',
  'styling.none': 'Bezaksiz',
  'styling.none_hint': 'Rasm va ismni bezaksiz qoldirish',
  'styling.buy': '❤ {price} ga sotib olish',
  'styling.equip': 'Taqish',
  'styling.equipped': 'Taqilgan',
  'styling.remove': 'Yechish',
  'styling.owned': 'Sizniki',
  'styling.vip_only': 'Faqat VIP',
  'styling.reward.league_champion': 'Mukofot: kunlik ligada gʻalaba',
  'styling.reward.kiss_master': 'Mukofot: 1000 ta oʻpich olish',
  'bottle.put': '❤ {price} ga stolga qoʻyish',
  'bottle.pick': 'Butilkani tanlang',
  'bottle.title': 'Butilkani almashtirish',
  'bottle.hint': 'Butilka shu stoldagi hamma uchun almashadi.',
  'bottle.current': 'Stolda',
  'bottle.changed': '{name} stolga «{skin}» butilkasini qoʻydi 🍾',
  'table.change_bottle': 'Butilkani almashtirish',
  'bottle.classic': 'Klassik',
  'bottle.emerald': 'Zumrad',
  'bottle.amber': 'Qahrabo',
  'bottle.champagne': 'Shampan',
  'bottle.cola': 'Kola',
  'bottle.lemonade': 'Limonad',
  'bottle.whisky': 'Viski',
  'bottle.wine': 'Qizil vino',
  'bottle.sparkle': 'Uchqunli',
  'bottle.ice': 'Muzli',
  'bottle.gold': 'Oltin',
  'bottle.potion': 'Sehrli sharbat',
  'bottle.baby': 'Bolalar shishasi',
  'bottle.vip': 'VIP',
  'frame.rose_garden': 'Atirgul bogʻi',
  'frame.neon_pink': 'Pushti neon',
  'frame.neon_cyan': 'Feruza neon',
  'frame.hearts': 'Yurakchalar',
  'frame.candy': 'Konfet',
  'frame.bow': 'Bantik',
  'frame.leaves': 'Kuz',
  'frame.flame': 'Alanga',
  'frame.ice': 'Muz',
  'frame.butterfly': 'Kapalak',
  'frame.emerald': 'Zumrad',
  'frame.ruby': 'Yoqut',
  'frame.sapphire': 'Sapfir',
  'frame.devil': 'Shayton',
  'frame.angel': 'Farishta',
  'frame.galaxy': 'Galaktika',
  'frame.rainbow': 'Kamalak',
  'frame.royal': 'Qirollik',
  'frame.vip_gold': 'VIP oltin',
  'frame.vip_diamond': 'VIP olmos',
  'frame.league_champion': 'Liga chempioni',
  'frame.kiss_master': 'Oʻpich ustasi',
  'stickers.title': 'Mening stikerlarim',
  'stickers.pack.basic': 'Asosiy',
  'stickers.pack.love': 'Sevgi',
  'stickers.pack.party': 'Bayram',
  'stickers.pack.animals': 'Hayvonlar',
  'stickers.pack.vip': 'VIP',
  'stickers.cost': 'Har bir stiker ❤ {price} turadi va avataringiz ustida koʻrinadi.',
  'stickers.buy': '❤ {price} ga ochish',
  'stickers.vip_only': 'VIP oʻyinchilar uchun',
  'ratings.emotional': 'Eng hissiyotli',
  'wheel.title': 'Omad gʻildiragi',
  'wheel.spin': 'Aylantirish',
  'wheel.chances': 'Imkoniyatlar: {count}',
  'wheel.free': 'Kunlik bepul imkoniyat',
  'wheel.free_taken': 'Bepul imkoniyat ertaga yana boʻladi',
  'wheel.shop': 'Imkoniyatlar doʻkoni',
  'wheel.pack': '{count} ta imkoniyat',
  'wheel.pack_one': '1 ta imkoniyat',
  'wheel.help': 'Qanday ishlaydi',
  'wheel.help_text':
    'Har bir aylantirish bitta imkoniyat turadi. Sovrinni server quyidagi ehtimollar bilan tanlaydi; yutgan imkoniyatlaringizni yana ishlatish mumkin. Boosterlar liga oynasida ishlatiladi.',
  'wheel.odds': 'Ehtimollar',
  'wheel.won': 'Sovriningiz: {prize}',
  'wheel.jackpot_banner': '🎰 {name} jekpotni yutdi: {prize}!',
  'wheel.big_win_banner': '🎡 {name} gʻildirakda {prize} yutdi',
  'wheel.need_chance': 'Imkoniyat qolmadi: ertaga bepulini oling yoki quyida sotib oling.',
  'wheel.boosters': 'Mening boosterlarim',
  'wheel.prize.hearts_3': '❤ 3',
  'wheel.prize.hearts_5': '❤ 5',
  'wheel.prize.hearts_25': '❤ 25',
  'wheel.prize.hearts_100': '❤ 100',
  'wheel.prize.jackpot': 'Jekpot ❤ 1000',
  'wheel.prize.chance_1': '+1 imkoniyat',
  'wheel.prize.chance_3': '+3 imkoniyat',
  'wheel.prize.boost_x2': 'Booster ×2',
  'wheel.prize.boost_limit': 'Booster +10 limit',
  'wheel.prize.boost_bonus': 'Booster +5 ochko',
  'booster.x2': 'Liga ochkolarini ikki baravar',
  'booster.x2_desc': 'Olgan oʻpichlaringiz 5 daqiqa ikki baravar hisoblanadi (oʻpich-sovgʻalardan tashqari).',
  'booster.limit': 'Liga limitini oshirish',
  'booster.limit_desc': 'Olingan oʻpichlar uchun kunlik ochko limiti 10 ga oshadi.',
  'booster.bonus': 'Bonus liga ochkolari',
  'booster.bonus_desc': 'Darhol +5 liga ochkosi, har qanday limitdan tashqari.',
  'lobby.wheel': 'Gʻildirak',
  'league.title': 'Ligalar',
  'league.tier.wooden': 'Yogʻoch liga',
  'league.tier.bronze': 'Bronza liga',
  'league.tier.silver': 'Kumush liga',
  'league.tier.gold': 'Oltin liga',
  'league.tier.platinum': 'Platina liga',
  'league.tier.diamond': 'Olmos liga',
  'league.ends_in': 'Yakuniy natija {h} soat {m} daqiqadan keyin',
  'league.points': '★ {points}',
  'league.kiss_limit': 'Bugun oʻpichlar uchun ochko: {used} / {cap}',
  'league.zone_up': 'Yuqori ligaga oʻtish',
  'league.zone_down': 'Oldingi ligaga tushish',
  'league.rewards': 'Mukofotlar',
  'league.chest.red': 'Qizil sandiq',
  'league.chest.blue': 'Koʻk sandiq',
  'league.chest.wooden': 'Yogʻoch sandiq',
  'league.chest.box': 'Sovgʻa qutisi',
  'league.chest_contents': '❤ {hearts} + 🎲 {chances}',
  'league.box_contents': '{points}+ ochko uchun 🎲 {chances}',
  'league.place': '{place}-oʻrin',
  'league.empty':
    'Guruhga kirish uchun bugun birinchi ochkolaringizni yigʻing: sovgʻa yuboring, qoʻshiq buyurtma qiling, oʻyinchilarga xayrixohlik bildiring yoki oʻpich oling.',
  'league.rules': 'Qoidalar',
  'league.rules_text':
    'Ligalar — kunlik musobaqalar. Sovgʻa, musiqa va xayrixohlikka sarflangan har bir yurak hamda olingan har bir oʻpich uchun bir ochko beriladi (kuniga {cap} tagacha). Kun oxirida har guruhning birinchi {promote} nafari yuqori ligaga oʻtadi, oxirgi {demote} nafari pastga tushadi ({min}+ oʻyinchili guruhlarda). Birinchi uchtalik sandiq oladi, {box}+ ochko yigʻganlar sovgʻa qutisi oladi.',
  'league.use': 'Ishlatish',
  'league.x2_active': '×2 yoqilgan: {time}',
  'league.used.x2': 'Olingan oʻpichlar 5 daqiqa ikki baravar hisoblanadi!',
  'league.used.limit': 'Bugungi oʻpich limitingiz 10 ga oshdi.',
  'league.used.bonus': '+5 liga ochkosi!',
  'league.last_result': 'Oxirgi natija: {place}-oʻrin, {tier}',
  'league.moved_up': '⬆ Yuqoriga oʻtdi',
  'league.moved_down': '⬇ Pastga tushdi',
  'league.stayed': 'Oʻzgarishsiz',
  'league.result_toast': 'Liga natijasi: {place}-oʻrin. {chest}',
  'league.get_boosters': 'Boosterlarni Omad gʻildiragida yutib olish mumkin',
  'lobby.league': 'Liga',
  'achievement.kisser.title': 'Oʻpuvchi',
  'achievement.kisser.desc': 'Berilgan oʻpichlar: {count}',
  'achievement.popular.title': 'Mashhur',
  'achievement.popular.desc': 'Olingan oʻpichlar: {count}',
  'achievement.mutual.title': 'Oʻzaro mehr',
  'achievement.mutual.desc': 'Oʻzaro oʻpichlar: {count}',
  'achievement.spinner.title': 'Butilka ustasi',
  'achievement.spinner.desc': 'Butilka aylantirish: {count}',
  'achievement.regular.title': 'Doimiy mehmon',
  'achievement.regular.desc': 'Oʻynalgan raundlar: {count}',
  'achievement.generous.title': 'Saxiy',
  'achievement.generous.desc': 'Yuborilgan sovgʻalar: {count}',
  'achievement.adored.title': 'Sevimli',
  'achievement.adored.desc': 'Olingan sovgʻalar: {count}',
  'achievement.dj.title': 'DJ',
  'achievement.dj.desc': 'Buyurtma qilingan qoʻshiqlar: {count}',
  'achievement.chatty.title': 'Suhbatdosh',
  'achievement.chatty.desc': 'Chatdagi xabarlar: {count}',
  'achievement.daredevil.title': 'Jasur',
  'achievement.daredevil.desc': 'Bajarilgan topshiriqlar: {count}',
  'achievement.streak.title': 'Sodiq',
  'achievement.streak.desc': 'Ketma-ket kunlik bonus: {count} kun',
  'achievement.emotional.title': 'Hissiyotli',
  'achievement.emotional.desc': 'Yuborilgan stikerlar: {count}',
  'achievement.lucky.title': 'Omadli',
  'achievement.lucky.desc': 'Gʻildirak aylantirish: {count}',
  'achievement.admirer.title': 'Muxlis',
  'achievement.admirer.desc': 'Xayrixohliklar: {count}',
  'achievement.charmer.title': 'Jozibali',
  'achievement.charmer.desc': 'Sizga xayrixohlik: {count}',
  'achievement.champion.title': 'Chempion',
  'achievement.champion.desc': 'Liga sandiqlari: {count}',
  'achievement.league.title': 'Choʻqqiga',
  'achievement.league.desc': 'Liga: {count}/5',
  'achievement.bartender.title': 'Barmen',
  'achievement.bartender.desc': 'Butilka almashtirish: {count}',
  'achievement.secret.title': 'Yashirin muxlis',
  'achievement.secret.desc': 'Yashirin xabarlar: {count}',
  'ratings.expensive': 'Eng qimmat',
  'ratings.important': 'Eng muhim',
  'ratings.top': 'TOP',
  'ratings.help.kisses': 'Olingan oʻpichlar, oʻpich-sovgʻalar ham.',
  'ratings.help.dj':
    'Musiqaga sarflangan yuraklar va qoʻshigʻingiz paytida olgan har bir sovgʻa uchun bitta.',
  'ratings.help.expensive': 'Sizga oxirgi xayrixohlik narxi yoki muxlisni rad etgan narxingiz.',
  'ratings.help.important':
    'Boshqalarga xayrixohlikka sarflangan yuraklar; rad etilsangiz yoki sizdan oʻzib ketishsa ayriladi.',
  'ratings.help.emotional': 'Stikerlarga (imo-ishoralarga) sarflangan yuraklar.',
  'achievements.stars': '★ {stars} / {total}',
  'achievements.filter.all': 'Hammasi',
  'achievements.filter.done': 'Bajarilgan',
  'achievements.filter.locked': 'Yopiq',
  'achievements.next': 'Keyingi yulduz: {progress} / {goal} · ❤ {reward}',
  'achievements.complete': 'Barcha yulduzlar olindi!',
  'player.turn_down': 'Muxlisni rad etish',
  'player.turned_down': '{name} rad etildi',
  'notify.turned_down': '{name} sizni rad etdi',
  'activity.title': 'Bonus va reyting',
  'activity.today': 'Bugun',
  'activity.yesterday': 'Kecha',
  'activity.time': 'Faollik vaqti',
  'activity.time_value': '{h} soat {m} daqiqa',
  'activity.milestone': '{hours} soat → ❤ {reward}',
  'activity.points': 'Faollik ochkolari',
  'activity.how': 'Ochko qoidalari',
  'activity.kind.message': 'Chatdagi xabar',
  'activity.kind.song': 'Buyurtma qilingan qoʻshiq',
  'activity.kind.booster': 'Ishlatilgan booster',
  'activity.kind.gift': 'Yuborilgan sovgʻa',
  'activity.kind.round': 'Oʻynalgan raund',
  'activity.kind.sticker': 'Yuborilgan stiker',
  'activity.kind.wheel': 'Gʻildirak aylantirish',
  'activity.rules':
    'Vaqt stolda faol boʻlganingizda hisoblanadi (kamida har {gap} daqiqada bitta harakat). Kuniga {cap} tagacha xabar ochko beradi. Kunlik top yarim tunda yopiladi; birinchi {places} oʻrin yurak oladi. Spam hisobga olinmaydi.',
  'activity.top': 'Kunlik top-{size}',
  'activity.prize': '❤ {hearts}',
  'activity.ends_in': '{h} soat {m} daqiqadan keyin yopiladi',
  'activity.empty': 'Bugun hali faollik yoʻq.',
  'activity.reward_toast': 'Faollik mukofoti: ❤ {hearts}',
  'activity.top_toast': 'Kunlik faollik topi: {place}-oʻrin, ❤ {hearts}',
  'lobby.bonus': 'Bonus',
  'friends.title': 'Doʻstlar roʻyxati',
  'friends.add': 'Doʻst qoʻshish',
  'friends.requested': 'Soʻrov yuborildi',
  'friends.accept': 'Qabul qilish',
  'friends.decline': 'Rad etish',
  'friends.remove': 'Doʻstlardan oʻchirish',
  'friends.friends': 'Doʻstlar',
  'friends.incoming': 'Doʻstlik soʻrovlari',
  'friends.outgoing': 'Yuborilgan soʻrovlar',
  'friends.empty': 'Hali doʻst yoʻq.',
  'friends.online': 'onlayn',
  'friends.at_table': 'stolda',
  'friends.join': 'Qoʻshilish',
  'friends.count': 'Doʻstlar: {count}',
  'friends.hidden': 'Doʻstlar yashirilgan',
  'friends.privacy': 'Doʻstlarimni kim koʻradi',
  'friends.privacy.everyone': 'Hamma',
  'friends.privacy.me': 'Faqat men',
  'notify.friend_request': '{name} siz bilan doʻst boʻlmoqchi',
  'notify.friend_accepted': '{name} doʻstlik soʻrovingizni qabul qildi',
  'lobby.friends': 'Doʻstlar',
  'settings.gender': 'Jins',
  'settings.gender_hint': 'Har {days} kunda bir marta oʻzgartirish mumkin, stolda oʻtirganda emas.',
  'settings.gender_next': 'Keyingi oʻzgartirish: {date}',
  'errors.GENDER_COOLDOWN': 'Yaqinda jinsni oʻzgartirgansiz. Keyinroq urinib koʻring.',
  'errors.TOO_MANY_FRIENDS': 'Doʻstlar roʻyxati toʻlgan.',
  'errors.TRANSLATION_UNAVAILABLE': 'Tarjima hozir mavjud emas.',
  'table.show_translation': 'Tarjimani koʻrsatish',
  'table.hide_translation': 'Tarjimani yashirish',
  'table.translating': 'Tarjima qilinmoqda…',
  'player.league': '{league}',
  'player.send_gift_title': '{name} uchun sovgʻa',
  'settings.photo_change': 'Rasmni oʻzgartirish',
  'settings.photo_reset': 'Telegram rasmimni qaytarish',
  'settings.photo_hint':
    'Oʻz rasmingizni yuklamaguningizcha Telegram rasmingiz koʻrsatiladi. Nomaqbul rasmlar oʻchiriladi va ular uchun bloklanish mumkin.',
  'settings.photo_preview': 'Yangi rasm',
  'settings.photo_saved': 'Rasm yangilandi',
  'settings.name_reset': 'Telegram ismimni qaytarish',
  'errors.UNSUPPORTED_IMAGE': 'Bu rasmdan foydalanib boʻlmaydi. Boshqa rasm tanlang.',
  'lobby.domino': 'Domino',
  'domino.title': 'Domino',
  'domino.rules': 'Bozorli klassik domino · {target} ochkoga birinchi yetgan bankni oladi',
  'domino.rake': 'Komissiya {percent}%',
  'domino.quick': 'Tezkor oʻyin',
  'domino.free': 'Bepul',
  'domino.create': 'Xona ochish',
  'domino.seats': 'Oʻyinchilar',
  'domino.stake_label': 'Tikish',
  'domino.open_rooms': 'Oʻyinchi kutayotgan xonalar',
  'domino.no_rooms': 'Ochiq xona yoʻq: oʻzingiz oching yoki tezkor oʻyinni boshlang.',
  'domino.join': 'Qoʻshilish',
  'domino.back_to_game': 'Siz xonadasiz: oʻyinga qaytish',
  'domino.waiting': 'Oʻyinchilar kutilmoqda… {n}/{seats}',
  'domino.leave': 'Chiqish',
  'domino.leave_confirm': 'Oʻyindan chiqasizmi? Bu magʻlubiyat, tikish bankda qoladi.',
  'domino.leave_refund': 'Xonadan chiqish (tikish qaytadi)',
  'domino.pot': 'Bank ❤ {pot}',
  'domino.round': '{round}-raund · {target} gacha',
  'domino.your_turn': 'Sizning navbatingiz',
  'domino.turn_of': '{name} yurmoqda',
  'domino.draw': 'Bozordan olish ({n})',
  'domino.pass': 'Pas',
  'domino.choose_end': 'Qaysi uchiga?',
  'domino.left': '◀ Chapga',
  'domino.right': 'Oʻngga ▶',
  'domino.boneyard': 'Bozor {n}',
  'domino.drew': '{name} {n} ta oldi',
  'domino.passed': '{name}: pas',
  'domino.auto': '{name}: vaqt tugadi',
  'domino.round_won': '{name} raundni yutdi: +{points}',
  'domino.round_blocked': 'Yopiq! Eng kam ochko {name} da: +{points}',
  'domino.round_tie': 'Yopiq va durang: bu raundda ochko yoʻq',
  'domino.next_round': 'Keyingi raund {s} s dan keyin',
  'domino.game_won': '{name} oʻyinni yutdi!',
  'domino.you_won': 'Siz ❤ {payout} yutdingiz!',
  'domino.out': 'chiqdi',
  'domino.to_lobby': 'Xonalarga',
  'domino.cancelled': 'Xona yopildi, tikishlar qaytarildi.',
  'domino.started': 'Domino oʻyiningiz boshlandi!',
  'domino.points': '{score} ochko',
  'domino.empty_seat': 'Boʻsh joy',
  'domino.first_move': 'Yoritilgan dubl bilan boshlang',
  'errors.ILLEGAL_MOVE': 'Bu tosh u yerga toʻgʻri kelmaydi.',
  'errors.DOMINO_DISABLED': 'Domino mavjud emas.',
  'errors.ALREADY_IN_GAME': 'Siz allaqachon domino xonasidasiz.',
  'lobby.live': 'Jonli efir',
  'live.title': 'Jonli efir',
  'live.go_live': 'Efirga chiqish',
  'live.vip_only': 'Efirga VIP oʻyinchilar chiqadi, tomosha hammaga ochiq.',
  'live.connect_failed':
    'Efir videosiga ulanib boʻlmadi. Internetni tekshiring (yoki mobil internetda sinang) va qayta oching.',
  'live.no_webrtc':
    'Bu Telegram ilovasida efir videosi ishlamaydi. Oʻyinni telefondagi Telegramda yoki web.telegram.org orqali oching.',
  'live.empty': 'Hozir hech kim efirda emas.',
  'live.viewers': '{n} kishi koʻrmoqda',
  'live.start_title': 'Sizning efiringiz',
  'live.title_placeholder': 'Efiringiz nima haqida?',
  'live.rules':
    'Men 18 yoshdan kattaman. Yalangʻochlik va voyaga yetmaganlarni koʻrsatmayman, kontakt bermayman. Qoidani buzish efirni toʻxtatadi va akkaunt bloklanishi mumkin.',
  'live.start': 'Efirni boshlash',
  'live.camera_needed': 'Efirga chiqish uchun kamera va mikrofonga ruxsat bering',
  'live.end': 'Efirni tugatish',
  'live.end_confirm': 'Efirni hozir tugatasizmi?',
  'live.ended': 'Efir tugadi',
  'live.ended_reports': 'Efir shikoyatlardan keyin toʻxtatildi',
  'live.ended_admin': 'Admin efirni toʻxtatdi',
  'live.ended_lost': 'Efir egasi bilan aloqa uzildi',
  'live.back': 'Efirlarga',
  'live.chat_placeholder': 'Biror yoqimli soʻz yozing…',
  'live.sent_gift': '{name} {emoji} yubordi',
  'live.report': 'Shikoyat',
  'live.reported': 'Rahmat, adminlar koʻrib chiqadi.',
  'live.tap_sound': '🔊 Ovoz uchun bosing',
  'live.connecting': 'Ulanmoqda…',
  'live.gift_title': '{name} uchun sovgʻa',
  'live.you_are_live': 'Siz efirdasiz',
  'live.waiting_video': 'Video kutilmoqda…',
  'live.like': 'Layk',
  'live.gift': 'Sovgʻa',
  'live.camera': 'Kamera',
  'live.admin_tab': 'Efirlar',
  'live.admin_end': 'Toʻxtatish',
  'live.admin_reports': '{n} ta shikoyat',
  'live.admin_none': 'Hali efir boʻlmagan.',
  'errors.LIVE_DISABLED': 'Jonli efir mavjud emas.',
  'errors.ALREADY_LIVE': 'Siz allaqachon efirdasiz.',
  'errors.STREAM_ENDED': 'Efir tugagan.',

  'settings.title': 'Sozlamalar',
  'settings.sound': 'Tovushlar',
  'settings.music': 'Musiqa',
  'settings.notifications': 'Yashirin xabarlar haqida botda xabar berish',
  'settings.language': 'Til',
  'settings.name': 'Stoldagi ismingiz',
  'settings.birth_year': 'Tugʻilgan yil',
  'settings.blocked': 'Bloklangan oʻyinchilar',
  'settings.support': 'Yordam',
  'settings.saved': 'Saqlandi',

  'invite.title': 'Doʻstlarni taklif qilish',
  'invite.text': 'Doʻstingiz birinchi raundni oʻynaganda ikkalangiz ❤ {bonus} olasiz.',
  'invite.share': 'Havolani ulashish',
  'invite.copy': 'Havolani nusxalash',
  'invite.copied': 'Havola nusxalandi',
  'invite.stats': 'Taklif qilingan: {invited} · Mukofotlangan: {rewarded}',
  'invite.share_text': 'Keling, Butilka oʻynaymiz! 🍾💋',

  'notify.admired': '{name} ❤ {price} evaziga sizning muxlisingiz boʻldi',
  'notify.outbid': '{name} {target} uchun sizdan yuqori narx berdi',
  'notify.gift': '{name} sizga {emoji} sovgʻa qildi',
  'notify.achievement': 'Yutuq: {title} ★{level} (+❤ {reward})',
  'notify.referral': '+❤ {bonus}: {name} sizning taklifingiz bilan oʻyinga qoʻshildi!',
  'notify.wallet': '+❤ {amount}',
  'notify.gm': '💰 +{amount} GM',
  'notify.transfer_gm': '{name} sizga {amount} GM yubordi',
  'notify.transfer_hearts': '{name} sizga ❤ {amount} yubordi',

  'admin.live_reported': '🔴 {name} ning jonli efiri {reports} ta shikoyatdan keyin toʻxtatildi.',
  'admin.auto_mute': '⚠️ Avto-mute: {userId} oʻyinchi 24 soatda {reports} ta shikoyat oldi.',
  'admin.broadcast_done': '📣 Tarqatma tugadi: yuborildi {sent}, xato {failed}.',

  'bot.welcome':
    'Salom! Eng qiziqarli Butilka oʻyiniga tayyorlaning.\n\n👀 Atrofingizdagilarni koʻring va suhbat boshlang\n🎁 Kutilmagan sovgʻalar va qiziqarli topshiriqlar bilan almashing\n💌 Maxsus odamga yashirin xabar yuboring\n🎲 Stolda birga qiziqarli oʻyinlar oʻynang\n🎶 Fonda musiqa tinglang\n\n🎮 OʻYNASH tugmasini bosing va boshladik!',
  'bot.play_button': '🎮 OʻYNASH',
  'bot.menu_button': 'OʻYNASH',
  'bot.help': 'Butilka Mini App ichida oʻynaladi: 🎮 PLAY tugmasini bosing.',
  'bot.rate_limited': 'Soʻrovlar juda koʻp. Biroz sekinroq.',
  'bot.banned': 'Akkauntingiz bloklangan.',
  'bot.gm_credited': '💰 Hisobingizga +{amount} GM tushdi. Balans: {gm} GM',
  'bot.gm_debited': '💰 Admin hisobingizdan {amount} GM yechdi. Balans: {gm} GM',
  'bot.short_description': 'Butilkani aylantiring, oʻpishing, sovgʻa yuboring va musiqa qoʻying 💋',
  'bot.description':
    'Klassik Butilka oʻyini Telegramda: 12 kishilik stollar, oʻpishlar, sovgʻalar, ligalar, Omad gʻildiragi va musiqa. 18+.',
  'bar.heart_shop': 'Yuraklar doʻkoni',
  'bar.wheel': 'Omad gʻildiragi',
  'bar.league': 'Liga',
  'bar.misc': 'Boshqa',
  'bar.settings': 'Sozlamalar',
  'bar.exit': 'Chiqish',
  'bar.table': 'Stol',
  'bar.change_table': 'Stolni almashtirish',
  'menu.achievements': 'Yutuqlar',
  'menu.ratings': 'Reytinglar',
  'menu.bottle': 'Butilka',
  'menu.styling': 'Bezak',
  'menu.boosters': 'Busterlar',
  'table.spin_the_bottle': 'Butilkani aylantiring!',
  'table.spins_the_bottle': 'Butilkani aylantirmoqda',
  'table.order_song': 'Qoʻshiq buyurtma qilish — ❤ {price}',
  'table.order_video': 'Klip buyurtma qilish — ❤ {price}',
  'table.video_size': 'Video oʻlchami',
  'table.play_here': 'Shu yerda oʻynash',
  'gifts.send_to': 'Sovgʻa yuborish:',
  'player.profile': 'Profil',
  'player.admire_for': 'Muxlis boʻlish —',
  'player.reported': 'Rahmat, tekshirib chiqamiz.',
  'report.SPAM': 'Spam',
  'report.ABUSE': 'Haqorat',
  'report.SEXUAL_CONTENT': 'Behayo kontent',
  'report.UNDERAGE': '18 yoshdan kichik',
  'report.OTHER': 'Boshqa',
  'shop.title': 'Yurak sotib olish',
  'shop.details': 'Batafsil',
  'shop.vip_status': 'STATUS',
  'shop.for_friend_1': 'Doʻst uchun',
  'shop.for_friend_2': 'oling',
  'shop.bonus': '{percent}% BONUS',
  'shop.best_offer': 'Eng foydali',
  'shop.best_pick': 'Eng yaxshi tanlov',
  'shop.send': 'Yuborish',
  'shop.need_gm': '{gm} GM kerak. GM balansini toʻldirish uchun adminga murojaat qiling.',
  'shop.bought': '+❤ {hearts}',
  'shop.send_gm_title': 'Doʻstga GM {amount} yuborish',
  'shop.send_hearts_title': 'Doʻstga ❤ {amount} yuborish',
  'shop.send_left': 'Bugun qolgan yuborishlar: {count}',
  'shop.send_no_friends': 'Avval doʻst qoʻshing: stoldagi oʻyinchini bosing, keyin yashil + ni.',
  'shop.sent_gm': '{name}ga {amount} GM yuborildi',
  'shop.sent_hearts': '{name}ga ❤ {amount} yuborildi',
  'vip.perks':
    'VIP boʻling: noyob sovgʻalar yuboring, emojilardan foydalaning va ismingizning maxsus rangi bilan ajralib turing!',
  'wheel.rules': '«Aylantirish»ni bosing — Omad gʻildiragini ishga tushiring va mukofot oling!',
  'wheel.chances_label': 'Imkoniyatlar:',
  'wheel.price': 'Narxi:',
  'wheel.winner': 'Gʻolib',
  'wheel.jackpot_text': 'jekpotni yutdi va ❤ 1000 oldi',
  'wheel.big_win_text': '{prize} yutdi',
  'league.hint': 'Yuqoriga chiqish uchun busterlardan foydalaning',
  'league.boosters': 'Busterlar',
  'league.zone_up_hint': 'yuqori ligaga chiqish',
  'league.final_in': 'Yakuniy natijalar: {hours} soatdan keyin',
  'league.until_limit': 'Limitgacha:',
  'league.activate': 'Faollashtirish',
  'league.rules_1': 'Ligalar — yurak va noyob sovgʻalar yutish mumkin boʻlgan kundalik musobaqalar.',
  'league.rules_2':
    'Ochko sovgʻalar, olingan oʻpichlar, musiqa va muxlislik uchun beriladi. Sarflangan har bir yurak uchun bir ochko: sovgʻa qancha koʻp boʻlsa, ochko shuncha koʻp.',
  'league.rules_3':
    'Kun oxirida birinchi {promote} oʻyinchi keyingi ligaga chiqadi va sandiq oladi; oxirgi {demote} pastga tushadi.',
  'league.rules_4':
    'Olingan oʻpichlar kuniga koʻpi bilan {cap} ochko beradi. Omad gʻildiragidagi busterlar yordam beradi: ikki barobar ochko, yuqori limit va bonus ochkolar.',
  'achievements.mine': 'Mening yutuqlarim',
  'achievements.count': '{stars}/{total}',
  'achievements.show_first': 'Avval:',
  'achievements.completed': 'bajarilgan',
  'achievements.locked': 'yopiq',
  'achievements.detail': 'Yutuq',
  'achievements.meet': 'Olish uchun shartlarni bajaring:',
  'ratings.help_title': 'Bu reyting haqida',
  'ratings.period': 'Davr',
  'ratings.top_n': 'Eng yaxshi {n} oʻyinchi',
  'ratings.period_all': 'barcha vaqt',
  'ratings.period_month': 'shu oy',
  'ratings.period_week': 'shu hafta',
  'ratings.period_day': 'bugun',
  'styling.apply': 'Qoʻllash',
  'styling.owned_hint': 'Bu ramka sizniki.',
  'styling.buy_hint': 'Ramkani ❤ {price} ga sotib oling va taqing.',
  'styling.locked': 'Bu ramka — mukofot.',
  'settings.sounds': 'Ovozlar',
  'settings.invite': 'Doʻstlarni taklif qilish',
  'settings.friends': 'Doʻstlarim',
  'settings.contact': 'Biz bilan bogʻlanish',
  'friends.who_sees': 'Doʻstligimni kimlar koʻrsin?',
  'friends.visibility_everyone': 'Hamma',
  'friends.visibility_me': 'Faqat men',
  'friends.sent': 'Yuborilgan soʻrovlar: {count}',
  'activity.hours': '{hours} soat',
  'activity.more': 'YANA',
  'activity.less': 'YIGʻISH',
  'activity.h': 's',
  'activity.m': 'd',
  'activity.pts': '{points} ochko',
  'activity.my_place': 'Oʻrningiz: #{rank} · {points} ochko',
  'portal.logout': 'Chiqish',
  'portal.services': 'Xizmatlar',
  'portal.invited': 'Taklif qilinganlar',
  'portal.invited_empty': 'Havolangiz orqali hali hech kim qoʻshilmadi.',
  'portal.no_status': 'Hali status yoʻq',
  'portal.status_title': 'Statusingiz',
  'portal.status_placeholder': 'Oʻzingiz haqingizda yozing…',
  'portal.start': 'Boshlash',
  'portal.watch': 'Tomosha',
  'portal.license': 'Litsenziya',
  'portal.license_title': '{name} v2',
  'portal.license_text':
    '© {year}. Barcha huquqlar himoyalangan. Oʻpich va sovgʻalar virtual va faqat koʻngilxushlik uchun.',
  'services.store': 'Doʻkon',
  'services.balance': 'Balans:',
  'services.username': 'Foydalanuvchi',
  'services.game_name': 'Oʻyindagi ism',
  'services.profile': 'Profil',
  'services.password': 'Parolni oʻzgartirish',
  'services.password_text': 'Akkaunt parolini oʻzgartiring.',
  'services.gender': 'Jinsni oʻzgartirish',
  'services.gender_text': 'Jins maʼlumotini oʻzgartiring.',
  'services.name': 'Oʻyindagi ismni oʻzgartirish',
  'services.name_text': 'Oʻyinlarda koʻrinadigan ismni oʻzgartiring.',
  'services.photo': 'Profil rasmini oʻzgartirish',
  'services.photo_text': 'Profil rasmingizni sozlang.',
  'services.back': 'ORQAGA',
  'services.password_current': 'Joriy parol',
  'services.password_new': 'Yangi parol (kamida 6 ta belgi)',
  'services.password_repeat': 'Yangi parolni takrorlang',
  'services.password_hint': 'Parol bilan saytga ID orqali kirishingiz mumkin.',
  'services.password_mismatch': 'Parollar mos kelmadi.',
  'services.password_saved': 'Parol saqlandi.',
  'services.gender_later': 'Uni {date} dan keyin yana oʻzgartirish mumkin.',
  'services.name_telegram': 'Telegram ismimni olish ({name})',
  'services.photo_pick': 'Rasm tanlash',
  'services.photo_telegram': 'Telegram rasmimni olish',
  'login.title': 'Kirish',
  'login.login': 'ID yoki @username',
  'login.password': 'Parol',
  'login.submit': 'Kirish',
  'login.hint': 'Parol oʻyinda oʻrnatiladi: chiqish → Xizmatlar → Parolni oʻzgartirish.',
  'login.open_bot': 'Oʻyinni Telegramda ochish',
  'login.developer': 'Dasturchi kirishi',
  'watch.back': 'Orqaga',
  'watch.live_caps': 'JONLI',
  'watch.live_tab': 'Jonli ({count})',
  'watch.domino_tab': 'Domino ({count})',
  'watch.no_streams': 'Faol efir topilmadi.',
  'watch.first_stream': 'Birinchi efirni boshlash',
  'live.no_other_camera': 'Boshqa kamera yoʻq.',
  'courting.title': 'Muxlislik',
  'courting.text': '{name} sizga muxlis boʻldi —',
  'courting.ok': 'Yaxshi',

  // Daily horoscope (menu ≡ → Horoscope).
  'menu.horoscope': 'Burjlar',
  'horoscope.title': 'Bugungi burj bashorati',
  'horoscope.pick': 'Burjingizni tanlang',
  'horoscope.today': 'Bugun, {date}',
  'horoscope.love_title': 'Sevgi',
  'horoscope.lucky_number': 'Omadli raqam',
  'horoscope.lucky_color': 'Omadli rang',
  'horoscope.change': 'Burjni almashtirish',
  'portal.credits': '3D rasmlar: Microsoft Fluent Emoji (MIT). Burj belgilari: Freepik.',
  'horoscope.sign.aries': 'Hamal',
  'horoscope.sign.taurus': 'Savr',
  'horoscope.sign.gemini': 'Javzo',
  'horoscope.sign.cancer': 'Saraton',
  'horoscope.sign.leo': 'Asad',
  'horoscope.sign.virgo': 'Sunbula',
  'horoscope.sign.libra': 'Mezon',
  'horoscope.sign.scorpio': 'Aqrab',
  'horoscope.sign.sagittarius': 'Qavs',
  'horoscope.sign.capricorn': 'Jaddiy',
  'horoscope.sign.aquarius': 'Dalv',
  'horoscope.sign.pisces': 'Hut',
  'horoscope.general.0': 'Yangi tanishuvlar uchun yaxshi kun. Birinchi boʻlib salom bering.',
  'horoscope.general.1': 'Bugun kuchingiz joyida. Butilkani bir necha marta aylantiring!',
  'horoscope.general.2': 'Stoldagilardan biri siz haqingizda oʻylayapti.',
  'horoscope.general.3': 'Bugun yengil boʻling: hazil jiddiy gapdan koʻra koʻproq eshik ochadi.',
  'horoscope.general.4': 'Bugun kichik sovgʻa katta taassurot qoldirishi mumkin.',
  'horoscope.general.5': 'Birinchi taassurotingizga ishoning, bugun u sizni aldamaydi.',
  'horoscope.general.6': 'Tinch kun. Musiqa va suhbatdan zavqlaning.',
  'horoscope.general.7': 'Bugun omad jasurlar tomonida. Birinchi qadamni tashlang.',
  'horoscope.general.8': 'Eski doʻstingiz bugun sizni hayratda qoldirishi mumkin.',
  'horoscope.general.9': 'Bugun sabr oʻzini oqlaydi. Kechgacha xohlaganingizga erishasiz.',
  'horoscope.love.0': 'Bugungi oʻpich alohida bir narsaning boshlanishi boʻlishi mumkin.',
  'horoscope.love.1': 'Bugun tabassumingiz eng yaxshi sovgʻa.',
  'horoscope.love.2': 'Kimdir sizga yashirincha muxlis. Stol atrofiga qarang.',
  'horoscope.love.3': 'Hislaringizni ochiq ayting, buni qadrlashadi.',
  'horoscope.love.4': 'Bugun oʻzaro oʻpich ehtimoli juda yuqori.',
  'horoscope.love.5': 'Shoshilmang: eng yaxshisi vaqt bilan keladi.',
  'horoscope.color.0': 'Qizil',
  'horoscope.color.1': 'Pushti',
  'horoscope.color.2': 'Oltin',
  'horoscope.color.3': 'Koʻk',
  'horoscope.color.4': 'Yashil',
  'horoscope.color.5': 'Binafsha',
};
